"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnUsUsd = void 0;
class EnUsUsd {
    constructor() {
        this.locale = "en-us";
        this.dateFormat = {
            short: "MM/dd/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd MMMM dd, yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "Cn",
            negativePattern: "(Cn)"
        };
    }
}
exports.EnUsUsd = EnUsUsd;
